import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "search-container"
};
const _hoisted_2 = {
  class: "items-container"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, watch, computed } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'multi-select-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "选择项目"
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:visible", "update:value", "confirm"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dialogVisible = computed({
      get: () => props.visible,
      set: val => emit("update:visible", val)
    });
    const searchKeyword = ref("");
    const selectedItems = ref([]);
    // 初始化选中的项目
    watch(() => props.value, newVal => {
      selectedItems.value = [...newVal];
    }, {
      immediate: true,
      deep: true
    });
    // 根据搜索关键字过滤选项
    const filteredItems = computed(() => {
      if (!searchKeyword.value) return props.options;
      return props.options.filter(item => item.toLowerCase().includes(searchKeyword.value.toLowerCase()));
    });
    // 关闭对话框
    function handleClose() {
      dialogVisible.value = false;
    }
    // 取消选择
    function handleCancel() {
      dialogVisible.value = false;
    }
    // 确认选择
    function handleConfirm() {
      emit("update:value", selectedItems.value);
      emit("confirm", selectedItems.value);
      dialogVisible.value = false;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        width: "40%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: searchKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
          placeholder: "搜索",
          "prefix-icon": "Search",
          clearable: ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_checkbox_group, {
          modelValue: selectedItems.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedItems.value = $event),
          class: "checkbox-list"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, item => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              key: item,
              label: item,
              border: "",
              class: "checkbox-item"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});